import { Component, Input, ViewChild, OnDestroy, ElementRef, OnInit, ViewEncapsulation, PLATFORM_ID, Inject, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';
import { StorageService, UtilService, ScriptLoaderService, VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-intl-input',
  templateUrl: './intl-input.component.html',
  styleUrls: ['./intl-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IntlInputComponent implements OnInit, OnDestroy {

  public country = {
    iso: 'in',
    dialCode: '91',
    number: ''
  };
  @Input() control: FormControl;
  @Input() group: FormGroup;
  @Input() hideSuffixIcon?: boolean;
  @Input() checkCountry = true;
  @Input() placeholder: any = 'Your Mobile Number';
  @Input() icon = 'icon-phone';
  @Input() inputType = 'tel';
  @Input() errorEmit = new EventEmitter;
  @Input() validNoErr = 'Please enter a valid number';
  @ViewChild('mobileInput', { static: true }) public mobileInput: ElementRef<HTMLInputElement>;
  @Input() showHint = false;
  @Input() appearance = 'legacy';
  @Input() readOnly = false;
  @Output() numberEmit = new EventEmitter();
  public isValid;
  public error;
  public iti;
  checkIntlTelErrorSubs;

  constructor(
    public vars: VariablesService,
    public utilService: UtilService,
    public scriptLoaderService: ScriptLoaderService,
    public storageService: StorageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    this.loadScript();
    this.control.valueChanges.subscribe((val: string) => {
      this.checkValidation();
    });
  }
  /**Input element */
  intlInputInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.iti = (<any>window).intlTelInput(this.mobileInput.nativeElement, {
        preferredCountries: ['in', 'us', 'gb', 'ae'],
        customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
          return '';
          // return 'e.g. ' + selectedCountryPlaceholder;
        },
      });
      this.setCountry();
      this.onCountryChange();
      this.getNumber();
      this.onMobileNumberChange();
      this.checkIntlTelErrorSubs = this.utilService.checkIntlTelError.subscribe(
        check => {
          if (check === true) {
            this.checkValidation();
          }
        }
      );
    }
  }
  /**On Init set country */
  setCountry() {
    const selected_mobile_code = this.storageService.getFromSession('selected_mobile_code');
    const code = selected_mobile_code || this.storageService.getPropertyFromSession('iplocation', 'country_code');
    if (code && this.checkCountry) {
      this.iti.setCountry(code);
    }
    this.updateNumber();
    if (this.vars.fundraiser?.settings?.verify_mobile) {
      this.vars.leadGenData$.subscribe(res => {
        if (res?.countryCode) {
          this.iti.setCountry(res?.countryCode);
        }
      });
    }
  }
  /**Country change event */
  onCountryChange() {
    this.mobileInput.nativeElement.addEventListener('countrychange', () => {
      const countryData = this.iti.getSelectedCountryData();
      this.country['iso'] = countryData.iso2;
      this.country['dialCode'] = countryData.dialCode;
      this.checkValidation();
      this.updateNumber();
      this.storageService.addSessionData('selected_mobile_code', countryData.iso2);
    });
  }
  /**Get utilService.number */
  getNumber() {
    this.mobileInput.nativeElement.addEventListener('change', () => {
      this.updateNumber();
      this.control.setValue(this.control.value.replace(/^0+/, ''));
    });
  }
  /**update number */
  updateNumber() {
    const data = {
      number: this.iti.getNumber(),
      extn: '+' + this.iti.getSelectedCountryData().dialCode,
      selectedCountry: this.iti.getSelectedCountryData()
    };
    if (data.number.substr(0, 1) === '+') {
      data.number = data.number.replace(data.extn, '');
    }
    data.number = data.number.split(' ').join('');
    this.control.setValue(data.number.replace(/^0+/, ''));
    this.utilService.number.next(data);
    this.numberEmit.emit(data);
  }
  /**Error validation */
  onMobileNumberChange() {
    this.mobileInput.nativeElement.addEventListener('change', () => {
      this.checkValidation();
    });
    this.mobileInput.nativeElement.addEventListener('input', () => {
      this.checkValidation();
    });
  }
  /**Set erron in control */

  checkValidation() {
    if (this.iti?.isValidNumber()) {
      this.control.setErrors(null);
    } else {
      this.control.setErrors({ 'incorrect': true });
    }
  }

  /**Load script of the intl input */
  loadScript() {
    this.scriptLoaderService.load('intl_tel_input').then(() => {
    }).then(() => {
      this.scriptLoaderService.load('intl_tel_input_util').then((data) => {
        this.intlInputInit();
      }).catch(error => { });
    })
      .catch(error => { });
  }

  validNoMsg() {
    // return this.storageService.get('language') === 'English' ? 'Please enter a valid number' : 'कृपया एक सही मोबाइल नंबर दर्ज करें';
  }

  /**Called once, before the instance is destroyed.
   * Add 'implements OnDestroy' to the class.
   */
  ngOnDestroy() {
    this.mobileInput.nativeElement.click();
    if (this.checkIntlTelErrorSubs) {
      this.checkIntlTelErrorSubs.unsubscribe();
    }
  }
}
